import { locations } from "../endpoints/locations.endpoints";
import $axios from "../http/accessor";

const LocationService = {
  countries: (page: number = 1, count: number = 100) => {
    // Backend has a maximum count limit of 100
    const validCount = Math.min(count, 100);
    return $axios.get(locations.countries, {
      params: {
        page,
        count: validCount,
      },
    });
  },

  cities: (countryId: number, page: number = 1, count: number = 100) => {
    // Backend has a maximum count limit of 100
    const validCount = Math.min(count, 100);
    return $axios.get(locations.cities(countryId), {
      params: {
        page,
        count: validCount,
      },
    });
  },
};

export default LocationService;
